import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64885f7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper userbind" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cbim-logo-white" }, null, -1))
const _hoisted_3 = { class: "main userbind-main" }
const _hoisted_4 = { class: "userbind-title" }
const _hoisted_5 = { class: "userbind-content" }
const _hoisted_6 = { class: "help" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "support@cbim.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CbimSteps = _resolveComponent("CbimSteps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('message.yonghushoujibangding')), 1),
        _createVNode(_component_CbimSteps, {
          class: _normalizeClass(["cbim-steps", {'cbim-steps-en': $setup.currentLanguage == 'en'}]),
          active: $setup.currentStep,
          stepsTitle: $setup.stepsTitle
        }, null, 8, ["class", "active", "stepsTitle"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.currentComponent), {
            account: $setup.account,
            verifyCode: $setup.verifyCode,
            countryCode: $setup.countryCode,
            type: $setup.type,
            usage: "userbind",
            onGoNextProcess: $setup.handleNextProcess
          }, null, 40, ["account", "verifyCode", "countryCode", "type", "onGoNextProcess"]))
        ], 1024))
      ])
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('message.yonghushoujibangdingyudaokunnan')) + " ", 1),
      _hoisted_7,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.sendEmail')) + " ", 1),
      _hoisted_8,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.forHelp')), 1)
    ])
  ]))
}